module.exports = __webpack_public_path__ + "static/media/replace-driver-green.2001dc5c.svg";